export enum BasicConstants {
  USER_TOKEN = 'token',
  USER_REFRESH_TOKEN = 'refreshToken',
  USER_REFRESH_TOKEN_EXPIRY = 'expiresOn',
  USER_ID = 'id',
  USER_NAME = 'userName',
  USER_DATA = 'userData',
  COMPANY_LINK = 'companyLink',
  COMPANY_CODE = 'companyCode',
  COMPANY_USER = 'companyUser',
  LANG = 'language',
  AR = 'العربية',
  EN = 'English',
  REQUIRED ='required',
  MINLENGTH = 'minlength',
  MAXLENGTH = 'maxlength',
  MIN ='min',
  MAX = 'max',
  PATTERN = 'pattern',
  EMAIL ='email'

}
